import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Button,
    Input,
    Select,
    Space,
    DatePicker, Drawer, Form,
    Typography
} from "antd";
import { FORMAT_DATE, TYPE_METHOD_SUPPORT, TYPE_MODAL, TYPE_RESULT_SUPPORT } from "../../../constants/constants";

import { consoleLogUtil } from "../../../utils/consoleLogUtil";
import dayjs from "../../../utils/dayjsConfig";
import { CloseOutlined, SaveOutlined } from "@ant-design/icons";

const SupportDetailDrawer = ({ isOpen, onSave, type, onClose, randomID, data }) => {
    const [form] = Form.useForm();
    const [isFormChanged, setIsFormChanged] = useState(false);



    const onFinish = (values) => {
        consoleLogUtil("Final Form Values on Submit:", values);
        if (type === TYPE_MODAL.EDIT) {
            const updatedSupport = {
                ...data,
                ...values
            }
            consoleLogUtil("Updated Service on Edit:", updatedSupport);
            if (isFormChanged) {
                onSave(updatedSupport);
                onClose();
            } else {
                onClose();
            }
        } else {
            form.validateFields()
                .then((values) => {
                    const dataForm = {
                        ...values
                    }
                    onSave(dataForm);
                    onClose();
                })
        }
    }
    useEffect(() => {
        if (type === TYPE_MODAL.ADD) {
            form.resetFields();
            form.setFieldsValue({
                care_date: dayjs(),
                care_method: TYPE_METHOD_SUPPORT[0].value
            });
        } else if (type === TYPE_MODAL.EDIT && data) {
            form.setFieldsValue({
                care_date: data.care_date ? dayjs(data.care_date) : null,
                care_method: data.care_method ?? null,
                care_result: data.care_result ?? null,
                notes: data.notes ?? '',
            });
        }
    }, [type, randomID]);
    return (
        <Drawer
            title={type === TYPE_MODAL.ADD ? "Thêm hỗ trợ mới" : "Thông tin chi tiết hỗ trợ"}
            width={600}
            onClose={onClose}
            open={isOpen}
            styles={{
                body: {
                    paddingBottom: 80,
                },
            }}
            extra={null
            }
        >
            <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                onValuesChange={() => setIsFormChanged(true)}
            >
                <Row gutter={16}>

                    <Col span={8}>
                        <Form.Item
                            name="care_date"
                            label="Ngày hỗ trợ"
                            rules={[{ required: true, message: 'Vui lòng chọn ngày' }]}
                        >
                            <DatePicker
                                style={{ width: "100%" }}
                                format={FORMAT_DATE.DDMMYYYY}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="care_method"
                            label="Phương thức hỗ trợ"
                            rules={[{ required: true, message: 'Chọn phương thức' }]}
                        >
                            <Select
                                placeholder="Chọn phương thức"
                                options={TYPE_METHOD_SUPPORT}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="care_result"
                            label="Kết quả hỗ trợ"
                            rules={[{ required: true, message: 'Chọn kết quả' }]}
                        >
                            <Select
                                placeholder="Chọn kết quả"
                                options={TYPE_RESULT_SUPPORT}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="notes"
                            label="Ghi chú nội dung hỗ trợ"
                        >
                            <Input.TextArea rows={4} placeholder="Nhập ghi chú" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24} style={{ textAlign: "right" }}>
                        <Space>
                            <Button icon={<CloseOutlined />} onClick={onClose}>Đóng</Button>
                            <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                                Lưu
                            </Button>

                        </Space>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    )
}

export default SupportDetailDrawer;